/**
 * Mini Konfigurator Demo: startet CSS-Keyframe-Animationen, sobald die Section sichtbar ist.
 * Ohne dieses Skript bleiben die Animationen pausiert (siehe component-mini-konfigurator-demo.css).
 */
(function () {
  const SECTION_SELECTOR = '.mini-konfigurator-demo';
  const IN_VIEW_CLASS = 'mini-konfigurator-demo--in-view';
  const INIT_ATTR = 'data-mkd-initialized';
  const INTRO_SECTION_CLASS = 'konfigurator-intro-with-demo';
  const INTRO_LOOP_ATTR = 'data-mkd-intro-loop';
  /**
   * Nach Ende der Animation: so lange bleibt das Ausgangsbild sichtbar (in-view),
   * danach kurz Reset und sofortiger Neustart (Konfigurator-Intro-Section).
   */
  const INTRO_LOOP_PAUSE_MS = 1900;

  function parseLoopDurationMs(section) {
    const raw = getComputedStyle(section).getPropertyValue('--mkd-loop-duration').trim();
    const m = raw.match(/^([\d.]+)(s|ms)$/i);
    if (!m) return 8000;
    const n = parseFloat(m[1], 10);
    return m[2].toLowerCase() === 'ms' ? n : n * 1000;
  }

  /** Entspricht --mkd-anim-duration im Theme-CSS (Loop * 1.35), plus kleiner Puffer */
  function getIntroAnimCycleMs(section) {
    return parseLoopDurationMs(section) * 1.35 + 120;
  }

  const INTRO_ANIMATED_SELECTOR =
    '.mini-konfigurator-demo__canvas-toolbar,' +
    '.mini-konfigurator-demo__canvas > .mini-konfigurator-demo__row,' +
    '.mini-konfigurator-demo__toolbar-value,' +
    '.mini-konfigurator-demo__chip,' +
    '.mini-konfigurator-demo__cta';

  /**
   * forwards-Animationen laufen beim erneuten --in-view nicht von selbst neu:
   * Animationen abbrechen und Inline-Reset erzwingen.
   */
  function resetIntroDemoKeyframeState(section) {
    section.querySelectorAll(INTRO_ANIMATED_SELECTOR).forEach(function (el) {
      if (typeof el.getAnimations === 'function') {
        el.getAnimations().forEach(function (anim) {
          anim.cancel();
        });
      }
      el.style.setProperty('animation', 'none', 'important');
      void el.offsetHeight;
      el.style.removeProperty('animation');
    });
    void section.offsetWidth;
  }

  function startIntroDemoLoop(section) {
    if (!section || section.getAttribute(INTRO_LOOP_ATTR) === '1') return;
    section.setAttribute(INTRO_LOOP_ATTR, '1');

    let cycleTimer = null;
    let pauseTimer = null;

    function scheduleNextCycle() {
      if (cycleTimer !== null) window.clearTimeout(cycleTimer);
      if (pauseTimer !== null) window.clearTimeout(pauseTimer);
      const cycleMs = getIntroAnimCycleMs(section);
      cycleTimer = window.setTimeout(function () {
        if (!section.isConnected) return;
        cycleTimer = null;
        /* Animationsende: Endzustand bleibt sichtbar (mini-konfigurator-demo--in-view unverändert) */
        pauseTimer = window.setTimeout(function () {
          if (!section.isConnected) return;
          pauseTimer = null;
          section.classList.remove(IN_VIEW_CLASS);
          resetIntroDemoKeyframeState(section);
          window.requestAnimationFrame(function () {
            if (!section.isConnected) return;
            section.classList.add(IN_VIEW_CLASS);
            void section.offsetWidth;
            scheduleNextCycle();
          });
        }, INTRO_LOOP_PAUSE_MS);
      }, cycleMs);
    }

    scheduleNextCycle();
  }

  function activateSection(section) {
    if (!section || section.classList.contains(IN_VIEW_CLASS)) return;
    section.classList.add(IN_VIEW_CLASS);
    if (
      section.classList.contains(INTRO_SECTION_CLASS) &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(min-width: 990px)').matches
    ) {
      startIntroDemoLoop(section);
    }
  }

  function observeSection(section) {
    if (!section || section.getAttribute(INIT_ATTR) === 'true') return;
    section.setAttribute(INIT_ATTR, 'true');

    if (typeof IntersectionObserver === 'undefined') {
      activateSection(section);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activateSection(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '0px 0px -48px 0px',
        threshold: 0.08,
      }
    );

    observer.observe(section);
  }

  function initMiniKonfiguratorDemo(root) {
    const scope = root && root.nodeType === Node.ELEMENT_NODE ? root : document;
    const sections = new Set();

    if (typeof scope.matches === 'function' && scope.matches(SECTION_SELECTOR)) {
      sections.add(scope);
    }
    scope.querySelectorAll(SECTION_SELECTOR).forEach((el) => sections.add(el));

    sections.forEach(observeSection);
  }

  function initOnReady() {
    initMiniKonfiguratorDemo(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnReady);
  } else {
    initOnReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (target && target.nodeType === Node.ELEMENT_NODE) {
      initMiniKonfiguratorDemo(target);
    }
  });
})();
